import React from 'react';
import {Button, Modal, Form, Select, Input} from 'semantic-ui-react';

function getTitle(action) {
  if (action === 'ADD') {
    return 'CREAR NUEVA DESCRIPCIÓN';
  } else if (action === 'UPDATE') {
    return 'ACTUALIZAR DESCRIPCIÓN';
  }
  return 'ELIMINAR DESCRIPCIÓN';
}

const ModalContainer = ({
  open,
  close,
  action,
  form,
  options,
  handleChange,
  handleSubmit,
}) => {
  const {description, code} = form;
  return (
    <Modal size='small' open={open} onClose={close}>
      <Modal.Header>{getTitle(action)}</Modal.Header>
      {action !== 'DELETE' ? (
        <Modal.Content>
          <Form>
            <Form.Field
              id='form-input-control-last-name'
              control={Input}
              label='Descripción'
              value={description}
              placeholder='Descripción'
              onChange={(e) => handleChange('description', e.target.value)}
            />
            <Form.Field
              label='Tipo'
              control={Select}
              options={options}
              value={code}
              onChange={(e, {value}) => handleChange('code', value)}
              search
            />
          </Form>
        </Modal.Content>
      ) : (
        <Modal.Content>
          <p>Esta segudo de eliminar el registro {form.description} ??</p>
        </Modal.Content>
      )}
      <Modal.Actions>
        <Button onClick={close}>Cerrar</Button>
        <Button onClick={handleSubmit} color='green'>
          Aceptar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ModalContainer;
